<template>
    <div v-loading="!is_ok" style="position: relative">
        <div style="width: 100%;height: 100%" ref="main"></div>
        <div class="select_btn">
            <el-date-picker
                class="sale_chart_time_ranges"
                v-model="timeRange"
                type="datetimerange"
                :clearable="false"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                align="right"
                size="mini"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="date_change"
                :default-time="['08:00:00', '07:59:59']">
            </el-date-picker>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'
import * as echarts from 'echarts/core';
import moment from 'moment'
import { TitleComponent,ToolboxComponent,TooltipComponent,GridComponent,LegendComponent,MarkLineComponent,MarkPointComponent } from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use(
    [TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LegendComponent, MarkLineComponent, MarkPointComponent, BarChart, CanvasRenderer]
);


export default {
    name: 'plan_charts',
    props:[

    ],
    data(){
        return {
            is_ok:false,
            timeRange:[],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            option:{
                title: {
                    show:true,
                    text:"实际装液量统计 (日)",
                    textStyle:{
                        color:"#95aac9",
                        fontWeight:"normal"
                    }
                },
                grid:{
                    right: '5%',
                    top:"25%",
                    bottom:"10%",
                    left:"15%"
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    top:"8%",
                    show:false
                },
                calculable: true,
                xAxis: [
                    {
                        data: []
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '装液量(吨)',
                        splitNumber:4,
                        axisLabel: {
                            formatter: '{value} 吨'
                        }
                    }
                ],
                series: [
                    {
                        name: '装液量',
                        type: 'bar',
                        data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
                        itemStyle:{
                            color:"rgb(83, 168, 255)",
                            borderRadius:[5,5,0,0],
                            shadowBlur:4,
                            shadowColor: 'rgba(0, 0, 0, 0.2)',
                            shadowOffsetY:1,
                            shadowOffsetX:1,
                        }
                    },
                ]
            },
            chart:null,
        }
    },
    methods:{
        date_change(value){
            this.getData()
        },
        getData(){
            this.is_ok = false;
            request.post("index/sale_amount_price_daily",{timeRange:this.timeRange}).then(res=>{
                let arr = [];
                for(let time of res.data.formattedTimes){
                    arr.push(moment(time).format("MM/DD"));
                }
                this.option.xAxis[0].data =arr;
                this.option.series[0].data = res.data.weights;
                this.is_ok = true;
                this.chart = echarts.init(this.$refs["main"]);
                this.chart.setOption(this.option);
            }).catch(err=>{
                this.is_ok = true;
            });
        },
         date_change(dateRange){
            this.timeRange = dateRange;
            this.getData();
        },
        getNextDate(date,day){
            let dd=new Date(date);
            dd.setDate(dd.getDate()+day);
            let y=dd.getFullYear();
            let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
            let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
            return y+'-'+m+'-'+d;
        }
    },
    created() {

    },
    mounted() {
        let dd=new Date();
        let y=dd.getFullYear();
        let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        let startTime=`${this.getNextDate(y+'-'+m+'-'+d,-5)} 08:00:00`
        let endTime=`${this.getNextDate(y+'-'+m+'-'+d,+0)} 7:59:59`
        this.timeRange.push(startTime,endTime)
        this.getData();
    }
}
</script>

<style scoped lang="scss">
.select_btn{
    position: absolute;
    top: 0px;
    right: 0px;
}

</style>
